<template>
  <div class="ui-container">
    <h2>Buttons</h2>
    <h3>Size</h3>
    <div class="ui-block inline">
      <Button class="primary sm" label=".btn.yellow.sm" />
      <Button class="primary" label=".btn.yellow" />
      <Button class="primary lg" label=".btn.yellow.lg" />
    </div>
    <h3>Full</h3>
    <div class="ui-block inline">
      <template v-for="color in colors" :key="color">
        <Button :class="color" :label="`.btn.${color}`" />
      </template>
    </div>
    <h3>Outline</h3>
    <div class="ui-block inline">
      <template v-for="color in colors" :key="color">
        <Button :class="`outline ${color}`" :label="`.btn.outline.${color}`" />
      </template>
    </div>
    <h3>Icon</h3>
    <div class="ui-block inline">
      <template v-for="color in colors" :key="color">
        <Button
          :class="`icon icon-left ${color}`"
          icon="bi bi-fan"
          :label="`.btn.icon.${color}`"
        />
      </template>
    </div>
    <div class="ui-block inline">
      <template v-for="color in colors" :key="color">
        <Button
          :class="`icon icon-right ${color}`"
          icon="bi bi-fan"
          :label="`.btn.icon.${color}`"
        />
      </template>
    </div>
    <h3>Icon outline</h3>
    <div class="ui-block inline">
      <template v-for="color in colors" :key="color">
        <Button
          :class="`icon icon-left outline ${color}`"
          icon="bi bi-fan"
          :label="`.btn.icon.outline.${color}`"
        />
      </template>
    </div>
    <div class="ui-block inline">
      <template v-for="color in colors" :key="color">
        <Button
          :class="`icon icon-right outline ${color}`"
          icon="bi bi-fan"
          :label="`.btn.icon.outline.${color}`"
        />
      </template>
    </div>
    <h3>Round icon</h3>
    <div class="ui-block inline">
      <small class="code-block" v-text="'.btn.round'" />
      <template v-for="color in colors" :key="color">
        <Button :class="`round ${color}`" icon="bi bi-fan" />
      </template>
    </div>
    <h3>Round icon outline</h3>
    <div class="ui-block inline">
      <small class="code-block" v-text="'.btn.round.outline'" />
      <template v-for="color in colors" :key="color">
        <Button :class="`outline round ${color}`" icon="bi bi-fan" />
      </template>
    </div>
    <h3>Square icon</h3>
    <div class="ui-block inline">
      <small class="code-block" v-text="'.btn.square'" />
      <template v-for="color in colors" :key="color">
        <Button :class="`square ${color}`" icon="bi bi-fan" />
      </template>
    </div>
    <h3>Square icon outline</h3>
    <div class="ui-block inline">
      <small class="code-block" v-text="'.btn.square.outline'" />
      <template v-for="color in colors" :key="color">
        <Button :class="`square outline ${color}`" icon="bi bi-fan" />
      </template>
    </div>
  </div>
</template>

<script setup>
const colors = ["primary", "secondary", "red", "green", "disabled"];
</script>
